module.exports = __webpack_public_path__ + "img/img_deposit_banner04.d8f5b4f0.png";